define(['block_exaport/config', 'block_exaport/touchpunch'], function (unused, touchpunch) {
  return '_';
});
